import { TimelineMax, TweenMax } from 'gsap';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useCountDown } from 'ahooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { endTime } from '@/data/ecocreditsday';
import { MUTI_AREA_ARR } from '@/componentsH5/EcoCreditsDay/components/AnchorTabs/constant';
import gtm from '@/utils/gtm';

export default function TimeLine() {
    const { t } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const { getSystemTime } = useGlobal();
    const start = getSystemTime();
    const end = endTime[locale as keyof typeof locale] || endTime.kr;
    const [countdown] = useCountDown({ leftTime: end - start });

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: '.timeline-content',
            offset: 100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 450,
        });
        const timeline = new TimelineMax();
        const tweenA = TweenMax.to('.timeline .title', 0.4, { opacity: 0.9 });
        const tweenA1 = TweenMax.to('.timeline-box', 0.8, { opacity: 1 });
        const tweenA2 = TweenMax.to('.timeline-box', 0.7, { rotationX: 0 });
        timeline.add(tweenA).add(tweenA1).add(tweenA2, 0.1);
        scene.setTween(timeline);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    return (
        <div className={`${styles.timeLine} timeline`}>
            {MUTI_AREA_ARR.includes(locale as string) && (
                <div className="title">{t.rich('timeLine.title', { line1: (text: any) => <span className="red-color">{text}</span> })}</div>
            )}
            <div className="timeline-content">
                <div className="timeline-box">
                    <div className="top-date">
                        <div className="left-date">{t('timeLine.date1')}</div>
                        <div className="right-date">{t('timeLine.date2')}</div>
                    </div>
                    <div className="line"></div>
                    <div className="bottom-text">
                        <div className="left-text">
                            {t('timeLine.date1_desc')}
                            {['kr'].includes(locale as string) && (
                                <div className="text-tip">{t.rich('timeLine.date1_tip', { line1: (text: string) => <span>{text}</span> })}</div>
                            )}
                        </div>
                        <div className="right-text">
                            {t('timeLine.date2_desc')}
                            {['kr', 'us', 'ca'].includes(locale as string) && <div className="text-tip">{t('timeLine.date2_tip')}</div>}
                        </div>
                    </div>
                </div>
            </div>
            {!['jp'].includes(locale as string) && countdown !== 0 && (
                <div
                    className="sale-text"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'ecocredits_button',
                            type: 'Other',
                            list_name: 'Introduction',
                            button_name: t('timeLine.sale_btn'),
                        });
                        const linkMap = {
                            za: `https://${locale}.ecoflow.com/pages/ecocredits-day-sale`,
                            au: 'https://au.ecoflow.com',
                        };
                        const link = linkMap[locale as keyof typeof linkMap] || linkMap.za;
                        window.open(link);
                    }}
                >
                    {t('timeLine.sale_btn')}
                </div>
            )}
        </div>
    );
}
